type ExceptionTagValue = string | number | boolean;
type ExceptionTags = Record<string, ExceptionTagValue>;

export default class Exception<Params = never> extends Error {
    readonly params: Params;
    tags: ExceptionTags = {};
    constructor(...[params]: [Params] extends [never] ? [] : [params: Params]) {
        super();
        this.name = new.target.name;
        this.params = params as Params;
    }

    setMessage(message: string) {
        this.message = message;
        return this;
    }

    setCause(from: unknown) {
        this.cause = from;
        return this;
    }

    setTags(tags: ExceptionTags) {
        this.tags = tags;
        return this;
    }
}
